import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!

  return (_openBlock(), _createBlock(_component_v_bottom_navigation, {
    modelValue: _ctx.currentMenu,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentMenu) = $event)),
    grow: "",
    color: "primary",
    style: {"box-shadow":"none","border-top":"1px #ddd solid"}
  }, {
    default: _withCtx(() => [
      (_ctx.enableBank)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            to: { name: 'bank' },
            value: "bank"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("$oss-bank")
                ])),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("menu.bank")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.userConfig.document.read)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            value: "documents",
            to: { name: 'documents' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("$oss-archives")
                ])),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("menu.documents")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.userConfig.expenseReport.read)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 2,
            to: { name: 'expenseReports' },
            value: "expenseReports"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("$oss-expense-report")
                ])),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("menu.expenseReportsLight")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.userConfig.business.dashboard)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 3,
            value: "dashboard",
            to: { name: 'dashboard' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("$oss-dashboard")
                ])),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("menu.dashboard")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}